import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSimpleCheckbox,{staticClass:"pa-2",attrs:{"value":_vm.selected,"indeterminate":_vm.disabled,"disabled":_vm.disabled,"color":"primary","ripple":false},on:{"input":function($event){return _vm.toggleItemSelection(_vm.itemId)}}})}
var staticRenderFns = []

export { render, staticRenderFns }